module.exports = __webpack_public_path__ + "img/Tessellate07.99f80d91.png";